// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionRequestDetailController = function ($scope, $routeParams, $http, ExternalSubscriptionRequestLog) {
    $scope.requestLog = ExternalSubscriptionRequestLog.get({ id: $routeParams.id }, function (data) {
        $scope.response = JSON.stringify(JSON.parse(data.Response), null, 2);
    });
};
ExternalSubscriptionRequestDetailController.$inject = ['$scope', '$routeParams', '$http', 'ExternalSubscriptionRequestLog'];
